
import vClickOutside from "v-click-outside";
import { mapGetters } from "vuex";
import cLoader from "../ui/c-loader.vue";
import ProfileCard from "@/components/v2/profile-card/profile-card.vue";

export default {
  components: {
    cLoader,
    ProfileCard,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    profiles: {
      type: Array,
      default: () => [],
    },
    showLoader: {
      type: Boolean,
      default: true,
    },
    mode: {
      type: String,
      default: "grid", // grid | list
      validator: (value) => ["grid", "list"].includes(value),
    },
    minCol: {
      type: Number,
      default: 2,
    },
    border: {
      type: Boolean,
      default: false,
    },
    favorites: {
      type: Boolean,
      default: false,
    },
    maxDisplayCount: {
      type: Number,
      default: null,
    },
    maxCol: {
      type: Number,
      default: 4,
    },
    groupByDate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      getIsProfilesAllShortLoading: "profiles/getIsProfilesAllShortLoading",
    }),

    profilesToDisplay() {
      if (this.maxDisplayCount) {
        return this.profiles.slice(0, this.maxDisplayCount);
      }
      return this.profiles;
    },

    groupedByDate() {
      if (!this.groupByDate) return this.profilesToDisplay;
      const grouped = {};
      this.profilesToDisplay.forEach((profile) => {
        const date = profile.activated_at.split(" ")[0];
        if (!grouped[date]) {
          grouped[date] = [];
        }
        grouped[date].push(profile);
      });
      return grouped;
    },

    cssVars() {
      return {
        "--min-col": this.minCol,
      };
    },

    itemsContainerClassList() {
      const classList = {};
      for (let i = this.minCol; i <= this.maxCol; i++) {
        if (this.mode === "list") break;
        if (i === 1) continue;
        classList[`grid-list__items-container--col-${i}`] = true;
      }
      return classList;
    },

    cardMode() {
      return this.mode === "list" ? "wide" : "compact";
    },
  },
  methods: {
    /**
     * Display date in a readable format
     * @param {String} date
     *
     * @returns {String}
     *
     * @example
     * Added today, June 10, 2024
     * Added yesterday, June 9, 2024
     * Added on June 8, 2024
     * Added on ...
     */
    displayDate(date) {
      const today = new Date();
      const dateObj = new Date(date);
      const diff = today.getDate() - dateObj.getDate();
      if (diff === 0) {
        return this.$t("added-today");
      }
      if (diff === 1) {
        return this.$t("added-yesterday");
      }
      return this.$t("added-on", [
        dateObj.toLocaleDateString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
        }),
      ]);
    },
  },
};
